import IntroProducts from 'gatsby-theme-dettol/src/components/Intro/IntroProducts/IntroProducts';
import './IntroProductsOverride.scss';

export default IntroProducts;
